import { console_log } from "./console_log";
/*------------------------------------- Filtering text handled in input Field -----------------------------------------------*/

// Helper function to remove all whitespace characters from a string.
export const stringSpacingValidation = (originalValue) => {
  if (typeof originalValue === "string") {
    return originalValue.replace(/\s/g, "");
  }
  return originalValue;
};

// Helper function to normalize spaces and filter out unwanted characters.
export const normalizeString = (value) => {
  if (typeof value === "string") {
    return (
      value
        .trim()
        // Replace disallowed characters (i.e., characters not in the allowed regex)
        .replace(/[^a-zA-Z0-9\s.,()@_\-!?$%[\]{}\/+'"]/g, " ")
        .replace(/ـ/g, " ") // Specific replacement for Arabic Tatweel character
        .replace(/\s+/g, " ")
    ); // Replaces multiple spaces with a single space
  }
  return value;
};

// Function to normalize spaces in various data types.
export const normalizeSpacesWithFilter = (value) => {
  if (typeof value === "string") {
    return normalizeString(value);
  } else if (Array.isArray(value)) {
    return value.map((item) => normalizeString(item));
  } else if (typeof value === "object" && value !== null) {
    const normalizedObject = {};
    for (const [key, nestedValue] of Object.entries(value)) {
      normalizedObject[key] = normalizeString(nestedValue);
    }
    return normalizedObject;
  } else {
    return value; // Return unchanged for non-string, non-array, non-object values
  }
};

// Function to trim spaces from all string values within an object.

export const trimSpacesFromObjectValues = (obj) => {
  const stringSpacingValidation = (value) => {
    if (typeof value === "string") {
      return value.trim().replace(/\s+/g, " ");
    }
    return value;
  };

  const recursiveTrim = (obj) => {
    if (typeof obj === "object" && obj !== null) {
      if (Array.isArray(obj)) {
        return obj.map((item) => recursiveTrim(item));
      } else {
        const trimmedObject = {};
        for (const [key, value] of Object.entries(obj)) {
          trimmedObject[key] = recursiveTrim(value);
        }
        return trimmedObject;
      }
    }
    return stringSpacingValidation(obj);
  };

  return recursiveTrim(obj);
};

// ==delete any key in object has a undefined value==
export const paramsValidate = (params) => {
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value === undefined || value === "" || value === "undefined") {
        delete params[key];
      }
      console_log(`${key}: ${value}`);
    }
  }
  console_log(params);
  return params;
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatPathname = (pathname) => {
  if (pathname === "/") return "Home"; // Handle root path
  return pathname
    .replace(/-/g, " ") // Replace hyphens with spaces
    .replace(/\//g, "") // Remove slashes
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
};

export const emailRegex =
  /^(?![.+_-])([a-zA-Z0-9]+[a-zA-Z0-9._%+-]*)[^._-]@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;
